import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SwitchListItem from '../../../../../../list-items/SwitchListItem/SwitchListItem';

const ParticlesSpeedShiftListItem = (props) => {
    const { particlesSpeedUpEnabled, updateElementsSettings } = props;

    const onSpeedShiftChange = (event) => updateElementsSettings({ 
        particles: { speedUpEnabled: event.target.checked }
    });

    return (
        <SwitchListItem
            text='Reactive Speed'
            checked={particlesSpeedUpEnabled}
            onChange={onSpeedShiftChange}
            toolTip='Particles will speed up during loud audio when this is enabled.'
        />
    );
};

const mapStateToProps = (state) => {
    const { speedUpEnabled: particlesSpeedUpEnabled } = state.createPreview.present.videoSettings.elements.particles;
    return { particlesSpeedUpEnabled };
}

const mapDispatchToProps = (dispatch) => {
    const updateElementsSettings = (properties) => dispatch(createActions.updateElementsSettings(properties));
    return { updateElementsSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticlesSpeedShiftListItem);